import { render, staticRenderFns } from "./news-media.vue?vue&type=template&id=33725878"
import script from "./news-media.vue?vue&type=script&lang=js"
export * from "./news-media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/news-media-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fdiscover-dfm%2Fnews-media.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/news-media-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fdiscover-dfm%2Fnews-media.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,FauxTabs: require('/vercel/path0/components/FauxTabs.vue').default})
